<template>
  <f7-page>
    <div v-if="loading" class="preloader-overlay">
      <div class="preloader-card">
        <f7-preloader />
        <div class="preloader-text">{{ $t('loading') }}</div>
      </div>
    </div>
    <ReportContainer :key="reloadKey" ref="reportContainer" />
  </f7-page>
</template>

<script>
import ReportContainer from '@/components/PowerBIEmbedded/index.vue';
import { mapActions, mapState } from 'vuex';
import { NOTIFY_TIME_LONG, POWERBI_REPORTS } from '@/js/constants';

export default {
  components: {
    ReportContainer,
  },
  data() {
    return {
      reportId: POWERBI_REPORTS[1]?.reportId || null,
      datasetIds: POWERBI_REPORTS[1]?.datasetId || null,
      reloadKey: 0,
      loading: true,
    };
  },
  computed: {
    ...mapState('contact', ['company']),
  },
  watch: {
    company(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.reloadKey += 1;
        this.loadReport();
      }
    },
  },
  beforeMount() {
    this.setCurrentRoute([
      {
        name: this.$t('agronomy'),
        disabled: false,
        page: 'AgronomySamplesPage',
        active: false,
      },
      {
        name: 'NutriVisor',
        disabled: true,
        page: 'Nutrivisor',
        active: true,
      },
    ]);
    this.setShowHeader('agronomy');
  },
  async mounted() {
    try {
      // this.$f7.preloader.show();
      this.loading = true;
      await this.loadReport();
    } catch (error) {
      this.$notifyDX(
        {
          message: this.$t(
            this.$helpers.getFilteredErrorMessage(error.message)
          ),
          width: 550,
        },
        'error',
        NOTIFY_TIME_LONG
      );
    } finally {
      // this.$f7.preloader.hide();
      this.loading = false;
    }
  },
  methods: {
    async loadReport() {
      if (!this.reportId || !this.datasetIds) {
        console.error('Report ID or Dataset IDs are missing.');
        return;
      }
      this.loading = true;
      await this.getInsertionToken({
        reportId: this.reportId,
        datasetIds: this.datasetIds,
      });
      const { reportContainer } = this.$refs;
      if (reportContainer) {
        await reportContainer.embedReport();
      }
      this.loading = false;
    },
    ...mapActions('breadcrumb', ['setCurrentRoute']),
    ...mapActions('PowerBiModules', ['getInsertionToken']),
    ...mapActions('filter', [
      'setCurrentFilter',
      'applyCurrentFilters',
    ]),
    ...mapActions('PowerBiModules', ['setShowHeader']),
  },
};
</script>
